import React from "react";
import { Card, CardContent, CardTitle } from "@ui/card";

interface PodcastCardProps {
  image: string;
  title: string;
  onClick?: () => void;
}

const PodcastCard = ({ image, title, onClick }: PodcastCardProps) => {
  return (
    <Card
      className="cursor-pointer border-none bg-transparent"
      onClick={onClick}
    >
      <CardContent className="p-0">
        <img
          src={image}
          alt="none"
          width={200}
          height={200}
          className="rounded-full"
        />
      </CardContent>
      <CardTitle>
        <p className="p-2 text-center text-[20px] font-normal dark:text-white">
          {title}
        </p>
      </CardTitle>
    </Card>
  );
};

export default PodcastCard;
